import React from 'react'

function SectionOne() {
  return (
    <>
      <div className='flex flex-col mx-auto items-center justify-center text-center w-[40rem]' style={{ fontFamily: 'Noto Serif' }} >
          <h1 className='text-[2rem] font-bold mt-10'> <span className='font-bold' style={{fontFamily: 'Yellowtail'}}>The Knot </span>+ SnapSage</h1>
          <h1 className='text-[2rem] text-[#2e1065] font-bold' >An Easier Way to Access Your Accounts</h1>
          <p className=' text-gray-800'>Together, our brands help you reach the largest audience of engaged couples anywhere - and now your new WeddingPro credentials help you sign in to both accounts in one simple place. </p>
      </div>
    </>
  )
}

export default SectionOne
